/* eslint-disable indent */
const hasContext = (/** @type {string} */ context) => window.contexts.includes(context);

import widgetsMgr from 'widgets/widgetsMgr';

import AddToWishlistMixinExt from './widgets/wishlist/AddToWishlistMixinExt';

widgetsMgr.addWidgetsList('global.wishlist.ext', () => [['productTile', AddToWishlistMixinExt, 'productTile']]);

widgetsMgr.asyncLists.push({
    getLoadingFlag: () => hasContext('header'),

    load: () =>
        Promise.all([
            import(/* webpackChunkName: 'wishlist.header' */ './widgets/header/WishlistIconExt').then(d => d.default),
            import(/* webpackChunkName: 'wishlist.header' */ './widgets/header/MiniWishlistDialog').then(d => d.default)
        ]).then(deps => {
            const [WishlistIconExt, MiniWishlistDialog] = deps;

            return {
                listId: 'wishlist.header.ext',
                widgetsDefinition: () => [
                    ['wishlistIcon', WishlistIconExt, 'wishlistIcon'],
                    ['miniwishlistDialog', MiniWishlistDialog, 'headerDialog']
                ]
            };
        })
});

widgetsMgr.asyncLists.push({
    getLoadingFlag: () => hasContext('pdp'),

    load: () =>
        Promise.resolve({
            listId: 'product.wishlist.ext',
            widgetsDefinition: () => [
                ['productDetail', AddToWishlistMixinExt, 'productDetail'],
                ['productSet', AddToWishlistMixinExt, 'productSet']
            ]
        })
});

widgetsMgr.asyncLists.push({
    getLoadingFlag: () => hasContext('wishlist'),

    load: () =>
        Promise.all([
            import(/* webpackChunkName: 'wishlist.wishlist' */ './widgets/wishlist/WishlistMgrExt').then(d => d.default),
            import(/* webpackChunkName: 'wishlist.wishlist' */ 'core/product/CoreAddToCartMixin').then(d => d.default),
            import(/* webpackChunkName: 'wishlist.wishlist' */ './widgets/product/WishlistAddToCartMixinExt').then(d => d.default),
            import(/* webpackChunkName: 'product.widgets' */ 'widgets/forms/ajax/BackInStock').then(d => d.default),
            import(/* webpackChunkName: 'product.widgets' */ 'core/forms/ajax/CoreBackInStock').then(d => d.default),
            import(/* webpackChunkName: 'product.widgets' */ 'core/product/AvailabilityReminderMixin').then(d => d.default),
            import(/* webpackChunkName: 'product.widgets' */ 'core/product/AvailabilityReminderModalMixin').then(d => d.default),
            import(/* webpackChunkName: 'product.widgets' */ 'core/product/SignInToBuyMixin').then(d => d.default),
            import(/* webpackChunkName: 'product.widgets' */ 'core/product/SignInToBuyModalMixin').then(d => d.default),
            import(/* webpackChunkName: 'product.widgets' */ 'core/product/EnrollLoyaltyToBuyModalMixin').then(d => d.default),
            import(/* webpackChunkName: 'product.widgets' */ 'widgets/product/ProductVariantSelect').then(d => d.default),
            import(/* webpackChunkName: 'product.widgets' */ 'core/product/CoreProductVariantSelect').then(d => d.default),
            import(/* webpackChunkName: 'wishlist.wishlist' */ 'core/global/ProductFocusManagementMixin').then(d => d.default),
            import(/* webpackChunkName: 'product.widgets' */ 'core/global/CoreSizeTabs').then(d => d.default),
            import(/* webpackChunkName: 'product.widgets' */ 'core/product/ProductActionButton').then(d => d.default),
            import(/* webpackChunkName: 'wishlist.wishlist' */ 'core/forms/ajax/SignInToBuyLoginForm').then(d => d.default),
            import(/* webpackChunkName: 'product.widgets' */ 'core/forms/ajax/EnrollLoyaltyToBuyLoginForm').then(d => d.default),
            import(/* webpackChunkName: 'wishlist.wishlist' */ 'core/global/SmsSubscriptionMixin').then(d => d.default),
            import(/* webpackChunkName: 'wishlist.wishlist' */ 'core/account/RegistrationForm').then(d => d.default),
            import(/* webpackChunkName: 'wishlist.wishlist' */ 'core/account/SignInToBuyRegistrationForm').then(d => d.default),
            import(/* webpackChunkName: 'wishlist.wishlist' */ 'core/product/PageLoadActionProcessor').then(d => d.default),
            import(/* webpackChunkName: 'wishlist.wishlist' */ 'core/product/ProductStoreSelector').then(d => d.default)
        ]).then(deps => {
            const [
                WishlistMgrExt,
                CoreAddToCartMixin,
                WishlistAddToCartMixinExt,
                BackInStock,
                CoreBackInStock,
                AvailabilityReminderMixin,
                AvailabilityReminderModalMixin,
                SignInToBuyMixin,
                SignInToBuyModalMixin,
                EnrollLoyaltyToBuyModalMixin,
                ProductVariantSelect,
                CoreProductVariantSelect,
                ProductFocusManagementMixin,
                CoreSizeTabs,
                ProductActionButton,
                SignInToBuyLoginForm,
                EnrollLoyaltyToBuyLoginForm,
                SmsSubscriptionMixin,
                RegistrationForm,
                SignInToBuyRegistrationForm,
                PageLoadActionProcessor,
                ProductStoreSelector
            ] = deps;

            return {
                listId: 'wishlist.wishlist.ext',
                widgetsDefinition: () => [
                    ['wishlistMgr', WishlistMgrExt, 'wishlistMgr'],
                    ['wishListItem', CoreAddToCartMixin, 'wishListItem'],
                    ['wishListItem', WishlistAddToCartMixinExt, 'wishListItem'],
                    ['wishListItem', AvailabilityReminderMixin, 'wishListItem'],
                    ['wishListItem', SignInToBuyMixin, 'wishListItem'],
                    ['backInStock', BackInStock, 'ajaxform'],
                    ['backInStock', CoreBackInStock, 'backInStock'],
                    ['drawerDialog', AvailabilityReminderModalMixin, 'drawerDialog'],
                    ['drawerDialog', SignInToBuyModalMixin, 'drawerDialog'],
                    ['drawerDialog', EnrollLoyaltyToBuyModalMixin, 'drawerDialog'],
                    ['productVariantSelect', ProductVariantSelect],
                    ['productVariantSelect', CoreProductVariantSelect, 'productVariantSelect'],
                    ['productVariantSelect', ProductFocusManagementMixin, 'productVariantSelect'],
                    ['sizeTabs', CoreSizeTabs, 'tabs'],
                    ['productActionButton', ProductActionButton, 'button'],
                    ['signInToBuyLoginForm', SignInToBuyLoginForm, 'loginForm'],
                    ['enrollLoyaltyToBuyLoginForm', EnrollLoyaltyToBuyLoginForm, 'loginForm'],
                    ['ajaxform', SmsSubscriptionMixin, 'ajaxform'],
                    ['registrationForm', RegistrationForm, 'ajaxform'],
                    ['signInToBuyRegistrationForm', SignInToBuyRegistrationForm, 'registrationForm'],
                    ['pageLoadActionProcessor', PageLoadActionProcessor],
                    ['productStoreSelector', ProductStoreSelector]
                ]
            };
        })
});
